export const PERIOD_TYPE_SORTING_ORDER: Record<string, number> = {
  Prompt: 1,
  Hour: 2,
  '12Hour': 3,
  HalfDay: 4,
  Day: 5,
  Week: 6,
  HalfMonth: 7,
  Cycle: 8,
  Month: 9,
  Quarter: 10,
  Season: 11,
  HalfYear: 12,
  Year: 13
};

export const isBeforeWithOrder = (
  valueA: unknown,
  valueB: unknown,
  order: Record<string, number>
) => {
  const keyA = String(valueA);
  const keyB = String(valueB);

  const hasKeyA = keyA in order;
  const hasKeyB = keyB in order;

  if (hasKeyA && hasKeyB) {
    return order[keyA] - order[keyB];
  }

  if (hasKeyA) return -1;
  if (hasKeyB) return 1;

  return keyA.localeCompare(keyB);
};
